import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { X, Megaphone } from "lucide-react";

const DISMISS_KEY = "kw_announcement_dismiss_v";

/**
 * Renders the admin-defined announcement as a dismissible popup.
 * Re-shows whenever the announcement is updated (updated_at changes)
 * OR the admin re-enables it after disabling.
 *
 * Stays visible until the admin disables it (enabled=false), per user choice.
 */
export default function AnnouncementPopup() {
  const [data, setData] = useState(null);
  const [dismissedKey, setDismissedKey] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) || ""; } catch { return ""; }
  });

  useEffect(() => {
    let alive = true;
    api.get("/settings/announcement")
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!data || !data.enabled || !data.title) return null;
  const key = `${data.updated_at || ""}`;
  if (dismissedKey === key) return null;

  const close = () => {
    try { localStorage.setItem(DISMISS_KEY, key); } catch { /* localStorage might be unavailable in private mode */ }
    setDismissedKey(key);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" data-testid="announcement-popup">
      <div className="kw-card max-w-lg w-full p-6 relative kw-fade-up">
        <button onClick={close} aria-label="Fechar"
          className="absolute top-3 right-3 text-[#A3A3A3] hover:text-white" data-testid="announcement-close">
          <X className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-2 mb-4 border-b border-[#222] pb-3">
          <Megaphone className="w-5 h-5 text-[#E50000]" />
          <div className="kw-overline">Anúncio</div>
        </div>
        <h2 className="font-display text-2xl font-black uppercase mb-3" data-testid="announcement-title">{data.title}</h2>
        <p className="text-[#A3A3A3] text-sm leading-relaxed whitespace-pre-wrap" data-testid="announcement-body">{data.body}</p>
        <button onClick={close} className="kw-btn-primary mt-5 w-full" data-testid="announcement-ok">
          OK, percebi
        </button>
      </div>
    </div>
  );
}
